import { IStoreComponent } from 'src/pages/indicators/EditIndicatorPage/types/storeComponent';

export const storeComponents: IStoreComponent[] = [
	{
		title: 'Indicador com ícone',
		exampleTemplate: 'iconIndicator(Descrição de teste, Teste, 999, checkOutlined)',
		description: 'Componente que exibe um valor númerico com um ícone',
		exampleView: {},
		template: {
			name: 'iconIndicator',
			arguments: [
				{
					name: 'Descrição',
					acceptArray: false,
					type: 'string',
					tooltip: 'Descrição do valor',
				},
				{
					name: 'Título',
					acceptArray: false,
					type: 'string',
					tooltip: 'Título do valor',
				},
				{
					name: 'Valor',
					acceptArray: false,
					type: 'string',
					tooltip: 'Valor númerico',
				},
				{
					name: 'Ícone',
					acceptArray: false,
					type: 'icon',
					tooltip: 'Ícone do valor',
				},
			],
		},
	},
	{
		title: 'Somador',
		exampleTemplate: 'adder({{example | toJson}},teste,Cupons essa semana, auditOutlined)',
		description: 'Componente que soma os valores de um campo específico do retorno de um observador',
		exampleView: { example: [{ teste: 239, },], },
		template: {
			name: 'adder',
			arguments: [
				{
					name: 'Observador',
					acceptArray: false,
					type: 'observer-select',
					tooltip: 'Array de objetos',
				},
				{
					name: 'Campo',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo a ser somado',
				},
				{
					name: 'Descrição',
					acceptArray: false,
					type: 'string',
					tooltip: 'Descrição do valor',
				},
				{
					name: 'Ícone',
					acceptArray: false,
					type: 'icon',
				},
			],
		},
	},
	{
		title: 'Gráfico de barras',
		exampleTemplate: 'barChart({{example | toJson}}, filial, cupons, Cupons por filial,)',
		description: 'Componente que exibe um gráfico de barras, agrupando os valores do retorno de um observador',
		exampleView: { example: [
			{
				filial: 'DF',
				cupons: 1400,
			},
			{
				filial: 'SP',
				cupons: 940,
			},
			{
				filial: 'RJ',
				cupons: 1430,
			},
			{
				filial: 'MG',
				cupons: 2039,
			},
		], },
		template: {
			name: 'barChart',
			arguments: [
				{
					name: 'Observador',
					acceptArray: false,
					type: 'observer-select',
					tooltip: 'Array de objetos',
				},
				{
					name: 'Eixo X',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do eixo X',
				},
				{
					name: 'Eixo Y',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do eixo Y',
				},
				{
					name: 'Título',
					acceptArray: false,
					type: 'string',
					tooltip: 'Título do gráfico',
				},
			],
		},
	},
	{
		title: 'Gráfico de pizza',
		exampleTemplate: 'pieChart({{example | toJson}}, filial, cupons, Cupons por filial)',
		description: 'Componente que exibe um gráfico de pizza, agrupando os valores do retorno de um observador',
		exampleView: { example: [
			{
				filial: 'DF',
				cupons: 1400,
			},
			{
				filial: 'SP',
				cupons: 940,
			},
			{
				filial: 'RJ',
				cupons: 1430,
			},
			{
				filial: 'MG',
				cupons: 2039,
			},
		], },
		template: {
			name: 'pieChart',
			arguments: [
				{
					name: 'Observador',
					acceptArray: false,
					type: 'observer-select',
					tooltip: 'Array de objetos',
				},
				{
					name: 'Rótulo',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do rótulo',
				},
				{
					name: 'Valor',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do valor',
				},
				{
					name: 'Título',
					acceptArray: false,
					type: 'string',
					tooltip: 'Título do gráfico',
				},
			],
		},
	},
	{
		title: 'Gráfico de linha',
		exampleTemplate: 'lineChart({{example | toJson}}, Crescimento A&B, data, tipo, valor)',
		description: 'Componente que exibe um gráfico de linha, agrupando os valores do retorno de um observador',
		exampleView: { example: [
			{
				data: '2021-01-01',
				tipo: 'A',
				valor: 100,
			},
			{
				data: '2021-01-02',
				tipo: 'A',
				valor: 200,
			},
			{
				data: '2021-01-03',
				tipo: 'A',
				valor: 94,
			},
			{
				data: '2021-01-01',
				tipo: 'B',
				valor: 234,
			},
			{
				data: '2021-01-02',
				tipo: 'B',
				valor: 120,
			},
			{
				data: '2021-01-03',
				tipo: 'B',
				valor: 350,
			},
		], },
		template: {
			name: 'lineChart',
			arguments: [
				{
					name: 'Observador',
					acceptArray: false,
					type: 'observer-select',
					tooltip: 'Array de objetos',
				},
				{
					name: 'Título',
					acceptArray: false,
					type: 'string',
					tooltip: 'Título do gráfico',
				},
				{
					name: 'Datas',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo da data',
				},
				{
					name: 'Tipo',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do tipo',
				},
				{
					name: 'Valor',
					acceptArray: false,
					type: 'observer-field',
					tooltip: 'Campo do valor',
				},
			],
		},
	},
	
];
